<template>
  <section class="user-info" v-if="ready">
    <div
      v-if="picture && showProfilePicture === true"
      class="user-info__image"
      :style="{ backgroundImage: 'url(' + picture + ')' }"
    />

    <div class="user-info__text">
      <p class="user-info__name">
        <strong>{{ firstName }} {{ lastName }}</strong>
      </p>

      <div class="user-info__links">
        <button @click="logout()" class="user-info__link" type="button">
          Sign out
        </button>
        <a :href="helpURL" class="user-info__link">Help</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "UserInfo",

  data() {
    return {
      ready: false,
      showProfilePicture: false,
      firstName: "",
      lastName: "",
      picture: "",
      helpURL: "https://www.avfc.co.uk/fans/digital-membership",
    };
  },

  mounted() {
    // load this user's latest information
    this.$getCurrentUserAttributes().subscribe(
      (userData) => {
        this.firstName = userData.given_name;
        this.lastName = userData.family_name;
        this.picture = userData.picture;

        // tell the app that we've finished loading
        this.ready = true;
      },
      (err) => {}
    );
  },
  methods: {
    logout() {
      this.$signOut();
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.user-info {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 260px;

  &__image {
    margin: 0 15px 0 0;
    height: 80px;
    width: 80px;
    background-size: cover;
    border-radius: 50%;
  }

  &__heading {
    margin: 0;
    padding: 0 0 5px;
    color: #660033;
    font-size: 20px;
    font-weight: 300;

    span {
      font-weight: 500;
    }
  }

  &__name {
    margin: 0;
    padding: 0 0 7px;
    font-size: 18px;
  }

  &__link {
    padding: 0;
    margin: 0 20px 0 0;
    color: #660033;
    font-size: 12px;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
